
<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Armsport Tournament </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<!-- <p>badminton-tournament works!</p> -->
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>G H Raisoni Memorial Armsport <span> District Level Competition
                    Pune </span></h2>
        </div>
        <div class="row">
            <div class="col-md-8 up-event-text mt-3">
                <h4 class="fw-bold">G H Raisoni Memorial District Level Armsport
                    Competition </h4>
                <h6 class="fw-bold">Date of competition :<strong>
                        11<sup>th</sup> February 2024 </strong></h6>
                <p>G H Raisoni Sports & Cultural Foundation Under the aegis of
                    Pune Armsport Association.</p>
                <strong>Domkhel Rd :</strong> Wagholi, Pune, Maharashtra 412207
                <br>
                <p><strong>Cash Prizes worth up to :</strong> 100000 <br>
                    <strong>Win :</strong> Trophies, Medals & Certificates <br>
                    <strong>Weight Category :</strong> Boys -
                    52kg,57kg,63kg,70kg,78kg,86kg,above86kg <br>
                    <strong>Weight Category :</strong> Girls -
                    45kg,49kg,54kg,60kg,67kg,above67kg, <br>
                    <strong>Contact :Dr. Vivek Mane </strong>:- 9156011073 <br>
                    <strong> Nishi Gandha Patil </strong> :- (+91-9527752939)
                    <br>
                    <strong> Reporting Time </strong> :- 10:00 AM<br>
                    <!-- <strong> Jay Singh Yadav </strong> :- 9689060159 <br> -->
                    <strong>Venue :</strong> G H Raisoni College of Engineering
                    and Management,
                    <br>
                    <strong>Get participate and win Trophies, Medals &
                        Certificates</strong>
                </p>
                <span class="date-event-up">February 2024</span>
                <!-- <a href="swimming-competition" target="_blank" class="btn button--effect-2 mx-2 btn-color"> Read More
                    <i class="fa fa-angle-double-right mx-1" aria-hidden="true"></i>
                </a> -->
            </div>
            <div class="col-lg-4 text-center">
                <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/armsport.avif"
                    alt="swimming-competition" title="swimming-competition"
                    class="img-fluid" />
            </div>
        </div>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-1">
            <div class="table-responsive">
                <table
                    class="table table-hover table-striped table-effect--primary shadow-soft">
                    <thead class="head-table">
                        <!-- <tr>
                            <th>G H Raisoni Memorial Armsport District Level Competition</th>
                        </tr> -->
                        <tr>
                            <th>S. No.</th>
                            <th>Price</th>
                            <th>Name</th>
                        </tr>
                    </thead>
                    <tbody class="tb-hover cust_ser_num">
                        <tr>
                            <td colspan="3" class="text-center"><strong>Girls
                                    Open Category</strong></td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>1st place</td>
                            <td>sunita Baban salekar</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>2nd place</td>
                            <td>Aakansha Jadhav</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>3rd place</td>
                            <td colspan="2">komal bhalerao</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="text-center"><strong>52 Kg
                                    BOYS</strong></td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>1st place</td>
                            <td>kartik Nagavade</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>2nd place</td>
                            <td>Gaurav Pawar</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>3rd place</td>
                            <td>Rohit Pawar</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="text-center"><strong>Boys
                                    57kg</strong></td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>1st place</td>
                            <td>Prashant A Pawar</td>
                        </tr>
                        <tr>
                            <td>8</td>
                            <td>2nd place</td>
                            <td>Ashwin Gupta</td>
                        </tr>
                        <tr>
                            <td>9</td>
                            <td>3rd place</td>
                            <td>Angad Rana</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="text-center"><strong>Boys
                                    63kg</strong></td>
                        </tr>
                        <tr>
                            <td>10</td>
                            <td>1st place</td>
                            <td>Abhishek Singh</td>
                        </tr>
                        <tr>
                            <td>11</td>
                            <td>2nd place</td>
                            <td>Sahil Bhandari</td>
                        </tr>
                        <tr>
                            <td>12</td>
                            <td>3rd place</td>
                            <td>Arvan Vasvani</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="text-center"><strong>Boys
                                    70KG</strong></td>
                        </tr>
                        <tr>
                            <td>13</td>
                            <td>1st place</td>
                            <td>Santosh Vaidhya</td>
                        </tr>
                        <tr>
                            <td>14</td>
                            <td>2nd place</td>
                            <td>Anand Kumar</td>
                        </tr>
                        <tr>
                            <td>15</td>
                            <td>3rd place</td>
                            <td>shrenic Ghanmode</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="text-center"><strong>Boys
                                    78kg</strong></td>
                        </tr>
                        <tr>
                            <td>16</td>
                            <td>1st place</td>
                            <td>Saurabh Singh</td>
                        </tr>
                        <tr>
                            <td>17</td>
                            <td>2nd place</td>
                            <td>Palash sarania</td>
                        </tr>
                        <tr>
                            <td>18</td>
                            <td>3rd place</td>
                            <td>sanket ingale</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="text-center"><strong>Boys
                                    86kg</strong></td>
                        </tr>
                        <tr>
                            <td>19</td>
                            <td>1st place</td>
                            <td>Atharva Bhagat</td>
                        </tr>
                        <tr>
                            <td>20</td>
                            <td>2nd place</td>
                            <td>Abhishek Sawant</td>
                        </tr>
                        <tr>
                            <td>21</td>
                            <td>3rd place</td>
                            <td>Rohan shinde</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="text-center"><strong>CHAMPION
                                    OF CHAMPIONS</strong></td>
                        </tr>
                        <tr>
                            <td>22</td>
                            <td>1st place</td>
                            <td>Atharva Bhagat</td>
                        </tr>
                        <tr>
                            <td>22</td>
                            <td>2nd place</td>
                            <td>Santosh Vaidhya</td>
                        </tr>
                        <tr>
                            <td>23</td>
                            <td>3rd place</td>
                            <td>kartik Nagavade</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div
                                class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a
                                href="https://drive.google.com/drive/folders/1KspOqFrt8vIwM2MlLaeHoZ7MhwMX5dw_"
                                target="_blank" class="cmn-button">
                                <span> View More</span>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul
                            class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm1.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm1.avif">
                                <a href="Javascript:void(0);">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm1.avif"
                                        alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm2.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm2.avif">
                                <a href="Javascript:void(0);">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm2.avif"
                                        alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm3.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm3.avif">
                                <a href="Javascript:void(0);">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm3.avif"
                                        alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm4.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm4.avif">
                                <a href="Javascript:void(0);">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm4.avif"
                                        alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm5.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm5.avif">
                                <a href="Javascript:void(0);">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm5.avif"
                                        alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm6.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm6.avif">
                                <a href="Javascript:void(0);">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm6.avif"
                                        alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>
